import { useEffect, useState } from "react";
import { useInterval } from "./interval";

type Props = {
	onLogout: () => void;
	timeToWarning: number;
	timeToLogout: number;
};

const events = [
	"mousedown",
	"click",
	"scroll",
	"keypress",
	"touchstart",
	"touchmove",
] as const satisfies Array<keyof GlobalEventHandlersEventMap>;

export const useIdleTimer = ({ onLogout, timeToWarning, timeToLogout }: Props) => {
	const [hasIdleWarning, setHasIdleWarning] = useState(false);
	const [baselineTime, setBaselineTime] = useState<number>(Date.now());

	useInterval(() => {
		const currentTime = Date.now();
		if (currentTime - baselineTime > timeToWarning) setHasIdleWarning(true);
		if (currentTime - baselineTime > timeToLogout) onLogout();
	}, 1000);

	useEffect(() => {
		const resetBaselineTime = () => {
			setHasIdleWarning((currentHasWarning) => {
				if (currentHasWarning) return true;
				const currentTime = Date.now();
				setBaselineTime(currentTime);
				return false;
			});
		};

		events.forEach((e) => {
			window.addEventListener(e, resetBaselineTime);
		});

		return () => {
			events.forEach((e) => {
				window.removeEventListener(e, resetBaselineTime);
			});
		};
	}, []);

	return {
		hasIdleWarning,
		resetIdleWarning: () => {
			const currentTime = Date.now();
			setBaselineTime(currentTime);
			setHasIdleWarning(false);
		},
	};
};
